import Service from "./Service"
import trust from "../../assets/images/ecommerce/trust.svg"
import open from "../../assets/images/ecommerce/open.svg"
import moreclients from "../../assets/images/ecommerce/moreclients.svg"
import sales from "../../assets/images/databases/sales.svg"

import sql from "../../assets/images/toCheck/sql.svg"
import stock from "../../assets/images/services/database.svg"
import calendar from "../../assets/images/toCheck/calendar.svg"
import blog from "../../assets/images/toCheck/blog.svg"
import autoadministrable from "../../assets/images/toCheck/autoadministrable.svg"
import gallery from "../../assets/images/toCheck/gallery.svg"
import videos from "../../assets/images/toCheck/videos.svg"
import testimonials from "../../assets/images/toCheck/testimonials.svg"
import chatbot from "../../assets/images/toCheck/chatbot.svg"
import map from "../../assets/images/toCheck/map.svg"
import calc from "../../assets/images/toCheck/calc.svg"
import form from "../../assets/images/toCheck/form.svg"
import reservation from "../../assets/images/toCheck/reservation.svg"
import other from "../../assets/images/toCheck/other.svg"
import brain from "../../assets/images/ecommerce/brain-ecommerce-bg.svg"

const ecommerce = {
  t1: "ecommerce_title",
  header: [
    "ecommerce_header1",
    "ecommerce_header2",
    "ecommerce_header3",
  ],
  time: "ecommerce_time",
  brain: brain,
  benefits: [
    {
      img: sales,
      text: "ecommerce_benefits1",
    },
    {
      img: open,
      text: "ecommerce_benefits2",
    },
    {
      img: moreclients,
      text: "ecommerce_benefits3",
    },
    {
      img: trust,
      text: "ecommerce_benefits4",
    },
  ],
  info: "ecommerce_info",
  toCheck: [
    {
      id: "database",
      text: "ecommerce_check1",
      img: sql,
    },
    {
      id: "stock",
      text: "ecommerce_check2",
      img: stock,
    },
    {
      id: "calendar",
      text: "ecommerce_check3",
      img: calendar,
    },
    {
      id: "blog",
      text: "ecommerce_check4",
      img: blog,
    },
    {
      id: "edit",
      text: "ecommerce_check5",
      img: autoadministrable,
    },
    {
      id: "gallery",
      text: "ecommerce_check6",
      img: gallery,
    },
    {
      id: "videos",
      text: "ecommerce_check7",
      img: videos,
    },
    {
      id: "testimonials",
      text: "ecommerce_check8",
      img: testimonials,
    },
    {
      id: "chat",
      text: "ecommerce_check9",
      img: chatbot,
    },
    {
      id: "map",
      text: "ecommerce_check10",
      img: map,
    },
    {
      id: "calc",
      text: "ecommerce_check11",
      img: calc,
    },
    {
      id: "formularios",
      text: "ecommerce_check12",
      img: form,
    },
    {
      id: "reservas",
      text: "ecommerce_check13",
      img: reservation,
    },
    {
      id: "another",
      text: "ecommerce_check14",
      img: other,
    },
  ],
};


const Ecommerce = () => {
    return (
        <Service service={ecommerce}/>
    )   
}

export default Ecommerce